module.exports = __webpack_public_path__ + "img/figure-7.ebb91512.png";